import React from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import config from '../config.js'

import {fetchDataIfReady} from 'Skelet/src/modules/fetch.action.js'
import {handleChange} from 'Skelet/src/modules/functions.js'
import ModalWrapper from 'Skelet/src/components/Modal_Wrapper.js'


class ModalCreateHighlight extends React.Component {

  constructor(props) {
    super(props);

    this.state = {name:"", work_ids:"", selected:0};
  }

  render() {
    if(this.props.shouldShow) {
      const submit_disabled = this.state.work_ids.trim() === "";

      let options = this.props.workIndex.data.map(function(item, i) {
        return <option key={"o"+i} value={item.id}>{item.role}{item.company && " @ "}{item.company && item.company}</option>;
      });

      let mapped_workids = null;
      if(this.state.work_ids !== "") {
        mapped_workids = this.state.work_ids.split(";;").map(function(work_id, i) {
          var item = this.props.workIndex.data.filter(function(work) {
            return work_id === ""+work.id;
          })[0];
          return <div key={"w"+i}>{item.role}{item.company && " @ "}{item.company && item.company}</div>;
        }.bind(this));
      }

      return (
        <ModalWrapper switchState={this.props.close} mainClass="create-poll">
          <form onSubmit={(e) => {e.preventDefault();this.submitForm()}}>
            <div><div>Highlight name<span style={{display:"block", opacity:".8", fontSize:"90%"}}>leave empty to display always, without URL affix</span></div><input type="text" value={this.state.name} onChange={(e) => handleChange(this, "name", e)} maxLength="100" placeholder="Name" autoFocus /></div>
            <div>Work Experience: <select value={this.state.selected} onChange={(e) => handleChange(this, "selected", e)}>
              {options}
            </select></div>
            <div><button type="button" className="btn btn-e" onClick={() => this.addWork()}>Add Work Experience</button></div>
            {mapped_workids}
            <div><input type="submit" value="Create" disabled={submit_disabled} /></div>
          </form>
        </ModalWrapper>
      );
    } else {
      return null;
    }
  }

  addWork() {
    const {work_ids} = this.state;
    let wi_arr = work_ids.split(";;");
    if(wi_arr.length > 0 && wi_arr[0] === "") wi_arr = [];
    let selected = this.state.selected;
    if(selected === 0 && this.props.workIndex && this.props.workIndex.data && this.props.workIndex.data[0]) selected = this.props.workIndex.data[0].id;
    wi_arr.push(selected);
    let new_work_ids = wi_arr.join(";;");
    this.setState({work_ids:new_work_ids});
  }

  submitForm() {
    const {name, work_ids} = this.state;
    const submit_disabled = work_ids.trim() === "";
    if(!submit_disabled) {
      this.props.fetchDataIfReady(config.api_token, "bin", "POST", config.api_url+"/highlight-create", JSON.stringify({session_token:this.props.session_token, name, work_ids}), null, true, false, false, false, false, null, "highlight-index");
      this.props.close();
      this.setState({name:"", work_ids:"", selected:this.props.workIndex.data[0].id});
    }
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalCreateHighlight)



// WEBPACK FOOTER //
// ./src/containers/ModalCreateHighlight.js